// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__JLpeT","overflowing":"ReadFullNote_overflowing__2Vp_t"};